import { ApiRequest } from "../../../api/ApiRequest";
import { ApiPaths } from "../../../api/ApiPaths";

export type GetListSuccessResponseType = {
    list: {
        careRecipient: {
            id: string,
            name: string,
            dataSyncInformation: {
                houseId: string,
                serviceProviderId: string | null,
                dataSyncPeriod: {
                    startTime: string | null,
                    endTime: string | null
                } | null
            } | null
            birthday: string
            createdTime: string
        },
        users: {
            id: string,
            name: string,
            account: {
                email: string,
                role: string
            }
        }[]
    }[]
    // API処理結果判別用：OK->undefined、NG->ErrorResponseType
    error: undefined
};

export async function getList(): Promise<GetListSuccessResponseType> {
    return await ApiRequest.get(
        ApiPaths.admin.list,
        {},
        () => {},
        () => {});
}
